import { getPage, pages } from "../siteContent";
import { NavLink } from "./NavLink";

export function RelatedLinks({ related = [], navigate, title = "Where to go next" }) {
  if (!related.length) return null;

  return (
    <section className="content-block side-links">
      <span className="section-eyebrow">Next shelf</span>
      <h2>{title}</h2>
      <div className="side-link-list">
        {related.map((relatedPath) => {
          const relatedPage = pages[relatedPath] || getPage(relatedPath);
          return (
            <NavLink key={relatedPath} to={relatedPath} className="side-link" onNavigate={navigate}>
              <strong>{relatedPage.title}</strong>
              <span>{relatedPage.description}</span>
            </NavLink>
          );
        })}
      </div>
    </section>
  );
}
